<div class="configurable-product-container">
  <nz-alert
    nzType="warning"
    nzMessage="Please choose an attribute set"
    *ngIf="showAttributeSetWarning === true"
  ></nz-alert>
  <nz-row *ngIf="showAttributeSetWarning === false">
    <legend>{{'Product Configuration' | translate}}</legend>
    <ng-container *ngFor="let inp of attributeInputs">
      <nz-input-group
        [nzAddOnAfter]="deleteAttributeTemp"
        nz-col
        nzSpan="6"
        style="padding: 0 20px"
      >
        <nz-select
          [nzDisabled]="Disabled"
          style="width: 100%"
          [(ngModel)]="inp.id"
          (ngModelChange)="onChoosingAttribute($event)"
        >
          <nz-option
            *ngFor="let attribute of attributes"
            [nzValue]="attribute.Code"
            [nzLabel]="attribute.Label"
          ></nz-option>
        </nz-select>
      </nz-input-group>
      <ng-template #deleteAttributeTemp>
        <button
          [disabled]="Disabled"
          nz-button
          nzType="text"
          type="button"
          nzDanger
          class="btn-delete-attribute"
          (click)="deleteAttrubyteInput(inp)"
        >
          <span nz-icon nzType="delete" nzTheme="outline"></span>
        </button>
      </ng-template>
    </ng-container>
    <div class="add-attribute-btn" nz-col nzSpan="6">
      <button
        [disabled]="Disabled"
        nz-button
        nzType="text"
        type="button"
        style="padding: 0; margin-inline: 10px"
        *ngIf="
          attributes.length > 0 && attributeInputs.length != attributesCount
        "
      >
        <span
          nz-icon
          nzType="plus"
          nzTheme="outline"
          (click)="addAttributeInput()"
          >{{'Add' | translate}}</span
        >
      </button>
    </div>
  </nz-row>
  <div class="submition-buttons" *ngIf="attributeInputs.length > 0">
    <button
      type="button"
      nz-button
      nzType="default"
      (click)="getProducts()"
      [disabled]="Disabled"
    >
      <span nz-icon nzType="cloud-download" nzTheme="outline"></span>
      {{'Get Products' | translate}}
    </button>
    <button
      type="button"
      nz-button
      nzType="default"
      (click)="reset()"
      [disabled]="Disabled"
    >
      <span nz-icon nzType="clear" nzTheme="outline"></span>{{'Reset Attributes' | translate}}
    </button>
  </div>
  <div style="padding: 20px 5%" *ngIf="products.length > 0">
    <nz-table [nzData]="products">
      <thead>
        <tr>
          <th
            [nzDisabled]="Disabled"
            [nzChecked]="checked"
            [nzIndeterminate]="indeterminate"
            (nzCheckedChange)="onAllChecked($event)"
          ></th>
          <th>{{'Name'  | translate}}</th>
          <th>{{'Sku' | translate}}</th>
          <th>{{'Price' | translate}}</th>
          <th *ngFor="let att of attributeInputs">
            {{
              baseAttributesCopy
                | ValueFromArray : "Label" : { name: "Code", value: att.id }
            }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products">
          <ng-container>
            <td
              [nzDisabled]="Disabled"
              [nzChecked]="setOfCheckedId.has(product.id!)"
              (nzCheckedChange)="onItemChecked(product.id!, $event)"
            ></td>
            <td>{{ product.name }}</td>
            <td>{{ product.sku }}</td>
            <td>{{ product.price }}</td>
            <td *ngFor="let att of attributeInputs">
              {{
                attributeOptionsMetadata[att.id]
                  | ValueFromArray
                    : "Label"
                    : {
                        name: "Code",
                        value:
                          product.attributeValues
                          | ValueFromArray
                            : "optionValueId"
                            : { name: "attributeId", value: att.id }
                      }
              }}
            </td>
          </ng-container>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <div
    style="padding: 20px 5%"
    *ngIf="products.length == 0 && showNoData === true"
  >
    <nz-empty nzNotFoundImage="simple"></nz-empty>
  </div>
</div>
